import { Box, Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const PreviewAccountItemEmpty = () => {
  return (
    <div className={styles.previewAccount}>
      <Box padding={'11px'}>
        <div className={styles.emptyIcon}></div>
      </Box>
      <Typography
        ariaLabel={'Account'}
        variant={'button-small'}
        color={'var(--content-primary-primary)'}
        ellipsis
      >
        Review account
      </Typography>
      <Box marginLeft={'auto'} marginRight={'11px'}>
        <Icon
          fontSize={16}
          icon={'arrowRightUp'}
          color={'var(--content-primary-disabled)'}
          ariaLabel={'Open link'}
        />
      </Box>
    </div>
  )
}
